<template>
	<div class="grid grid-cols-3 gap-x-4 items-center">
		<div class="col-span-2 flex items-center">
			<input
				type="checkbox"
				v-model="active"
				class="mt-0.5 h-5 w-5 border-gray-300 rounded text-orange-500 focus:ring-orange-500"
			/>
			<label
				class="ml-3 leading-5"
				:for="inputId"
				:class="[markInvalid ? 'text-red-600' : 'text-gray-700']"
			>
				<span class="font-medium whitespace-nowrap">{{
					__(parameter.name)
				}}</span>
				<span
					class="whitespace-nowrap"
					v-if="parameter.prefix != null || parameter.sufix != null"
					>({{ parameter.prefix }} {{ parameter.suffix }})</span
				>
				<p v-if="markInvalid">{{ validationMessage }}</p>
			</label>
			<div
				class="ml-4 flex-grow h-4 border-gray-300 border-b border-dotted"
			></div>
		</div>
		<div class="relative">
			<span v-if="parameter.type == 'checkbox'">
				{{ active ? __("Yes") : __("No") }}
			</span>
			<ui-input
				v-else
				v-model="inputValue"
				:key="'quality.' + parameter.id + '-' + active"
				:disabled="!active"
				autocomplete="off"
				:inputId="inputId"
				:markInvalid="markInputInvalid"
				:dp="parameter.dp"
			></ui-input>
			<div
				class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-red-600"
				v-if="markInvalid"
			>
				<ui-icon class="h-5 w-5" name="alert-triangle" stroke-width="1.5" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		form: {
			type: Object,
			required: true,
		},
		parameter: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			// dp: this.parameter.dp  ? this.parameter.dp : null,
			inputValue: this.form.quality[this.parameter.id],
			originalInputValue: this.form.quality[this.parameter.id],
			defaultInputValue: this.form.quality[this.parameter.id],
		};
	},
	computed: {
		active: {
			get() {
				return (
					this.inputValue != null ||
					(this.parameter.required && this.parameter.required == true)
				);
			},
			set(val) {
				if (val == false) {
					this.inputValue = null;
				} else if (this.parameter.type == "checkbox") {
					this.inputValue = "1";
				} else {
					this.inputValue = this.defaultInputValue || "";
				}
			},
		},
		inputId() {
			return "input-" + this._uid;
		},
		markInvalid() {
			return (
				this.form.hasErrors &&
				this.form.errors["quality." + this.parameter.id] != null
			);
		},
		markInputInvalid() {
			return this.markInvalid && this.inputValue == this.originalInputValue;
		},
		validationMessage() {
			return this.form.errors["quality." + this.parameter.id] || "";
		},
	},
	watch: {
		inputValue(val) {
			this.form.quality[this.parameter.id] = val;
		},
	},
	created() {
		this.$bus.$on("poll-is-mark-invalid", this.validationEventListener);
	},
	beforeDestroy() {
		console.log("TURNING OFF", this.field);
		this.$bus.$off("poll-is-mark-invalid", this.validationEventListener);
	},
	methods: {
		validationEventListener() {
			let that = this;
			that.$bus.$emit(
				"is-mark-invalid",
				"quality." + that.parameter.id,
				that.markInvalid
			);
		},
	},
};
</script>
